module.exports = __webpack_public_path__ + "static/media/Fleet.ef23232a.svg";